module.exports = __webpack_public_path__ + "static/media/pic4.5c9488d1.jpg";